const RouterViewRender = {
  render() {
    return <RouterView />;
  },
};

export default RouterViewRender;
